// extracted by mini-css-extract-plugin
export var buttonContent = "stylization-view-module--button-content--i1DzJ";
export var buttonsWrapper = "stylization-view-module--buttons-wrapper--LwzWr";
export var card = "stylization-view-module--card--WVT2J";
export var container = "stylization-view-module--container--I8cnq";
export var content = "stylization-view-module--content--iW53g";
export var error = "stylization-view-module--error--O1S9A";
export var header = "stylization-view-module--header--xnn95";
export var item = "stylization-view-module--item--2TSHk";
export var list = "stylization-view-module--list--oSEft";
export var postTitles = "stylization-view-module--post-titles--e4oUm";
export var productCardMinimal = "stylization-view-module--product-card-minimal--IzEDX";
export var section = "stylization-view-module--section--9Hai8";
export var shareWrapper = "stylization-view-module--share-wrapper--I3iLM";
export var shareallbutton = "stylization-view-module--shareallbutton--R7bH6";
export var sharebuttons = "stylization-view-module--sharebuttons--2XymW";
export var stylizationHeader = "stylization-view-module--stylization-header--SGUDN";
export var text = "stylization-view-module--text--DwRH2";
export var titleSvg = "stylization-view-module--title-svg--vyaHo";
export var tryOnButton = "stylization-view-module--try-on-button--Xbev3";
export var virtualTryOnContainer = "stylization-view-module--virtual-try-on-container--mg8Wx";
export var virtualTryOnContainerImage = "stylization-view-module--virtual-try-on-container-image--DNYEt";